// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"video-camera-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 10.2L16 11.001L16.001 11.002L16 10.2ZM16 10.2L16 5.001L11.001 5.00198M11.001 5.00198H10.001L10 5.00098L11.001 5.00198ZM23.0001 16V5.99998L16.5 9.89998M23.0001 16V17L23.0011 17.001L23.0001 16ZM16 16V19H1V5H5L16 16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 21L3 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const VideoCameraOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-off',
    ref,
    icon: element,
  },
));

VideoCameraOffIcon.displayName = 'VideoCameraOffIcon';

export default VideoCameraOffIcon;
